export enum BindType {
    NotBound = 0,
    OnAcquire = 1,
    OnEquip = 2,
    OnUse = 3,
    Quest = 4,
    Unused5 = 5,
    Unused6 = 6,
    ToGameAccount = 7,
    ToBnetAccount = 8,
    ToBnetAccountUntilEquipped = 9,
}
